import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { IntroText, CheckboxList, FormActionDrawer } from "../../../components";
import { useHeader } from "../../../contexts";
import {
  formatAmount,
  formatApiValuesFromCheckboxList,
  formatCheckboxListFromApiValues
} from "../../../utils";
import {
  SERVICE_COVID_19_TEST,
  SERVICE_FLU_SHOT,
  SERVICE_CONSULT
} from "../../../constants";
import { useTranslation } from "react-i18next";

const ALL_SERVICES = [
  {
    label: "COVID-19 Test",
    value: SERVICE_COVID_19_TEST
  },
  {
    label: "Consult",
    value: SERVICE_CONSULT
  },
  {
    label: "Flu Shot",
    value: SERVICE_FLU_SHOT
  }
];

const ScheduleServiceSelection = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [selectedServices, setSelectedServices] = useState();
  const [availableServices, setAvailableServices] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTitle(t("schedule.service_selection.title"));
  }, []);

  /**
   * Reconcile location services with all services value and label
   *
   */
  useEffect(() => {
    if (
      scheduleData.locationServices &&
      Array.isArray(scheduleData.locationServices)
    ) {
      const { locationServices } = scheduleData;

      const availableServices = locationServices
        .map(locationService => {
          const [match] = ALL_SERVICES.filter(
            service => service.value === locationService.service_code
          );

          return match
            ? {
                value: match.value,
                label: `${match.label} (${formatAmount(
                  locationService.cost || 0
                )})`
              }
            : {};
        })
        .filter(service => service.value && service.label);

      if (availableServices.length > 0) setAvailableServices(availableServices);
    }
  }, [scheduleData]);

  const handleNext = availableServices => {
    const services = formatApiValuesFromCheckboxList(
      availableServices,
      selectedServices
    );

    if (selectedServices.length > 0) {
      updateScheduleData({
        serviceSelection: services
      });
    } else {
      setError(true);
    }
  };

  return (
    <Box data-cy="schedule-screen-service-selection">
      <IntroText>{t("schedule.service_selection.intro_text")}</IntroText>
      {error && (
        <Typography
          data-cy="schedule-screen-service-selection-error"
          color="error"
          pb={2}
        >
          {t("schedule.service_selection.error")}
        </Typography>
      )}
      {availableServices.length > 0 ? (
        <>
          <CheckboxList
            allowMultiple
            options={availableServices}
            onChange={setSelectedServices}
            initialValues={formatCheckboxListFromApiValues(
              scheduleData.serviceSelection
            )}
          />
          <FormActionDrawer
            setDrawerClearance={setDrawerClearance}
            handleNext={e => handleNext(availableServices)}
            loading={isSubmitting}
          />
        </>
      ) : (
        <Typography color="error">
          {t("schedule.service_selection.error_empty")}
        </Typography>
      )}
    </Box>
  );
};

export { ScheduleServiceSelection };
